<div id="sportsoccer_div"
     [ngStyle]="fixtureStyles.mainContainer"
     onscroll="Scroll_Table()">

  <div class="ui table SportBets_Tables" [ngStyle]="fixtureStyles.tableNoNBorder">

    <virtual-scroller #scroll [items]="mergedData"
                      [enableUnequalChildrenSizes]="true"
                      [bufferAmount]="_bufferAmount"
                      [ngStyle]="styles.virtualScroll"
                      class="{{ isScoreBox ? 'ScrollBar' : ''}}"

    >
      <div
        *ngFor="let item of scroll.viewPortItems;let i = index;"
        class="uniqueRow {{item.TypeOfList}} color_{{item.IndexOdd}}"
        [fixtureItem]="item"
        [indexOfItem]="i"
        [IndexOdd]="item.IndexOdd"
        [typeOfList]="item.TypeOfList"
        [isExpandShow]="expandShowMatchId === item.MatchId"
        (expandNotifier)="expandNotifierHandler($event,i)"
      ></div>

    </virtual-scroller>


  </div>

</div>


<style>
  ::-webkit-scrollbar {
    width: 3px;
  }

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #F5F5F5;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #000000;
  }
</style>
